import(/* webpackMode: "eager" */ "/vercel/path0/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/ApmProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AuthSharingWrapper"] */ "/vercel/path0/components/AuthSharingWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FeatureNotification"] */ "/vercel/path0/components/FeatureNotifications/FeatureNotification.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FeatureNotifications"] */ "/vercel/path0/components/FeatureNotifications/FeatureNotifications.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/Hotjar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/modals/SignupModalContainer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/providers/NextAuthProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/providers/ToasterProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AuthModalProvider"] */ "/vercel/path0/contexts/AuthModalContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ClickProvider"] */ "/vercel/path0/contexts/ClickContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CurrencyPreferenceProvider"] */ "/vercel/path0/contexts/CurrencyPreferenceContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ExchangeRateProvider"] */ "/vercel/path0/contexts/ExchangeRateContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FollowProvider"] */ "/vercel/path0/contexts/FollowContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NotificationProvider"] */ "/vercel/path0/contexts/NotificationContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["OnchainProvider"] */ "/vercel/path0/contexts/OnchainContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["OrganizationProvider"] */ "/vercel/path0/contexts/OrganizationContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PreferencesProvider"] */ "/vercel/path0/contexts/PreferencesContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ReferralProvider"] */ "/vercel/path0/contexts/ReferralContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ShareModalProvider"] */ "/vercel/path0/contexts/ShareContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["UserProvider"] */ "/vercel/path0/contexts/UserContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["VerificationProvider"] */ "/vercel/path0/contexts/VerificationContext.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@coinbase/onchainkit/src/styles.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@next/third-parties/dist/google/ga.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@next/third-parties/dist/google/gtm.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@next/third-parties/dist/ThirdPartyScriptEmbed.js");
;
import(/* webpackMode: "eager", webpackExports: ["Analytics"] */ "/vercel/path0/node_modules/@vercel/analytics/dist/react/index.mjs");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/local/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"\",\"arguments\":[{\"src\":\"./fonts/GeistVF.woff\",\"variable\":\"--font-geist-sans\",\"weight\":\"100 900\"}],\"variableName\":\"geistSans\"}");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/local/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"\",\"arguments\":[{\"src\":\"./fonts/GeistMonoVF.woff\",\"variable\":\"--font-geist-mono\",\"weight\":\"100 900\"}],\"variableName\":\"geistMono\"}");
